import React from 'react'

const CheckoutStepperContext = React.createContext({
  handlerFunc: () => {},
  setHandlerFunc: () => {},
})

export default CheckoutStepperContext
